import type { TopicFacet } from '../services/api'

/** Sort TopicFacets by relevance-desc, with doc-count as tie-break. */
export function topicFacetComparator(a: TopicFacet, b: TopicFacet): number {
  return (b.relevance ?? 0) - (a.relevance ?? 0) || (b.count ?? 0) - (a.count ?? 0)
}
